import { useFreeFortuneGenreList } from "repositories/hooks/useFreeFortuneGenreList";

import SectionTitle from "../atoms/SectionTitle";
import Link from "next/link";
import tw from "twin.macro";

const List = tw.ul`flex flex-wrap`;

const Item = tw.li`border border-solid border-[#cf73b2] rounded-2xl py-2.5 px-[14px] mr-2 mb-2 font-base text-xs leading-none tracking-[.35px] text-[#cf73b2]`;

const Section = tw.div`mt-5 mb-10`;

interface Props {
  className?: string;
}

export const AllLabel = ({ className }: Props) => {
  const { freeFortuneGenre, isLoading, isError } = useFreeFortuneGenreList();

  if (isLoading || isError) return null;

  return (
    <div tw="px-4" className={className}>
      <SectionTitle>カテゴリから他の無料占いを探す</SectionTitle>
      <Section>
        <List>
          {freeFortuneGenre.categories?.map((category) => {
            return (
              <Link
                key={category.id}
                href={`/free_fortune/category/${category.id}`}
              >
                <a>
                  <Item>{category.name}占い</Item>
                </a>
              </Link>
            );
          })}
        </List>
      </Section>
      <SectionTitle>ジャンルから他の無料占いを探す</SectionTitle>
      <Section>
        <List>
          {freeFortuneGenre.tags?.map((tag) => {
            return (
              <Link key={tag.id} href={`/free_fortune/tag/${tag.id}`}>
                <a>
                  <Item>{tag.name}占い</Item>
                </a>
              </Link>
            );
          })}
        </List>
      </Section>
      <SectionTitle>占術から他の無料占いを探す</SectionTitle>
      <Section>
        <List>
          {freeFortuneGenre.divinations?.map((divination) => {
            return (
              <Link
                key={divination.id}
                href={`/free_fortune/type/${divination.id}`}
              >
                <a>
                  <Item>{divination.name}占い</Item>
                </a>
              </Link>
            );
          })}
        </List>
      </Section>
    </div>
  );
};
